import { Collection } from '../Collection';
function findDelegatedTarget(eventTarget, currentTarget, selector) {
    if (!(eventTarget instanceof Element))
        return null;
    const boundary = (currentTarget instanceof Element) ? currentTarget : null;
    let node = eventTarget;
    while (node) {
        if (node.matches(selector))
            return node;
        if (boundary && node === boundary)
            break;
        node = node.parentElement;
    }
    return null;
}
export class EventManager {
    static add(item, eventName, selector, callback, useCapture) {
        const listener = function (event) {
            if (selector) {
                const realTarget = findDelegatedTarget(event.target, event.currentTarget, selector);
                if (realTarget)
                    callback.call(realTarget, event, new Collection(realTarget));
            }
            else {
                callback.call(this, event, new Collection(this));
            }
        };
        const eventMap = EventManager.events.get(item) || {};
        const eventList = eventMap[eventName] || [];
        eventList.push({
            callback: callback,
            selector: selector,
            listener: listener,
            useCapture: !!useCapture
        });
        eventMap[eventName] = eventList;
        EventManager.events.set(item, eventMap);
        item.addEventListener(eventName, listener, !!useCapture);
    }
    static remove(item, eventName, selector, callback, useCapture) {
        const eventMap = EventManager.events.get(item);
        if (!eventMap || !eventMap[eventName])
            return;
        const remainingListeners = [];
        eventMap[eventName].forEach((record) => {
            const isSelectorMatch = (typeof selector === 'undefined') || record.selector === selector;
            const isCallbackMatch = (typeof callback === 'undefined') || record.callback === callback;
            const isCaptureMatch = (typeof useCapture === 'undefined') || record.useCapture === !!useCapture;
            if (isSelectorMatch && isCallbackMatch && isCaptureMatch) {
                item.removeEventListener(eventName, record.listener, record.useCapture);
            }
            else {
                remainingListeners.push(record);
            }
        });
        if (remainingListeners.length === 0) {
            delete eventMap[eventName];
        }
        else {
            eventMap[eventName] = remainingListeners;
        }
        EventManager.events.set(item, eventMap);
    }
}
EventManager.events = new WeakMap();
